import {
  CheckIfGroupIsFinishedRule,
  CheckIfTheTicketGroupCanBeSoldRule,
  CheckSalesOpeningRule,
  ConcatStatusSessionInDateTicketRule,
  IdentifyTicketWithCarouselIdRule,
  SortTicketsByDateAndClosingAndStockRule,
  SortTicketsByOrderRule
} from '../implementations';
import { Rule } from '../Rule';
import { RuleSetStrategy } from './RuleSetStrategy';

export class DefaultEventRuleSetStrategy implements RuleSetStrategy {
  getRules(): Rule[] {
    return [
      new CheckSalesOpeningRule(),
      new CheckIfGroupIsFinishedRule(),
      new IdentifyTicketWithCarouselIdRule(),
      new SortTicketsByDateAndClosingAndStockRule(),
      new CheckIfTheTicketGroupCanBeSoldRule(),
      new ConcatStatusSessionInDateTicketRule(),
      new SortTicketsByOrderRule(),
    ];
  }
}
